import { render, staticRenderFns } from "./DashboardHeaderComponent.vue?vue&type=template&id=d5906e7a&scoped=true"
import script from "./DashboardHeaderComponent.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeaderComponent.vue?vue&type=style&index=0&id=d5906e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5906e7a",
  null
  
)

export default component.exports